<wec-loading></wec-loading>
<shared-header (onLanguageChange)="onLanguageChange($event)"></shared-header>
<router-outlet></router-outlet>
<app-mini-footer></app-mini-footer>
<app-snackbar #snackbar></app-snackbar>